import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-end Rotis" }
const _hoisted_2 = { class: "col text-progression-bar bg-white no-padding" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = {
  class: "col bg-primary q-pl-md q-pr-xl q-pt-sm q-pb-sm",
  style: {"min-width":"270px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 static no-print" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 static print" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _hoisted_5
      ])
    ]),
    _hoisted_6,
    _hoisted_7
  ]))
}